import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <IndexSection />
        <AppSection />
        <CardsSection />
        <FeaturesSection />
        <TopicsSection />
        <UpdatesSection />
        <CommentsSection />
        <MediaSection />
        <RankingSection />
        <AboutSection />
        <FaqSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}